<div #tableWrapper class="siteTable__wrapper">
  <div #table class="customSiteTable"></div>

  <div class="timelinePointContainer" [class.timelinePointContainer--hidden]="isTimelinePage()">
    <router-outlet></router-outlet>
  </div>
</div>
